import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    id: "faq-1",
    question: "What do you need from me?",
    answer:
      "Plans (PDF preferred), project details, scope notes, and any constraints or specs you have. The more detail, the more accurate the estimate. We'll confirm what's included before we start.",
  },
  {
    id: "faq-2",
    question: "What's your turnaround time?",
    answer:
      "Standard turnaround is 3-5 business days depending on project size and complexity. Rush turnaround is available for urgent jobs, just let us know what you need.",
  },
  {
    id: "faq-3",
    question: "Can you price civil and residential?",
    answer:
      "Yes. We handle small residential builds (new builds, renovations, extensions) and small civil works (drainage, driveways, retaining walls, small earthworks). If it's a large commercial or complex civil project, we'll let you know upfront if it's outside our scope.",
  },
  {
    id: "faq-4",
    question: "Do you provide marked-up plans?",
    answer:
      "Not currently. We provide structured BOQs, labour breakdowns, and clear summaries rather than marked-up drawings. This keeps outputs clean and easy to use for pricing and procurement.",
  },
  {
    id: "faq-5",
    question: "Can you work in NZ and Australia?",
    answer:
      "Yes. We service both New Zealand and Australia, including the Sunshine Coast / Peregian Beach area. Everything is handled online so location isn't a barrier.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="py-16 md:py-24 border-t-4 border-black bg-white"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-12 md:mb-16">
          <span className="font-mono text-sm uppercase tracking-widest text-zinc-500">
            06 — FAQ
          </span>
          <h2
            className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase mt-4"
            data-testid="faq-title"
          >
            Common Questions
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-0">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={faq.id}
              value={faq.id}
              className={`border-2 border-black ${
                index > 0 ? "border-t-0" : ""
              }`}
              data-testid={`faq-item-${faq.id}`}
            >
              <AccordionTrigger
                className="px-6 py-5 hover:no-underline hover:bg-zinc-50 font-heading font-bold text-left uppercase text-base md:text-lg [&[data-state=open]]:bg-zinc-50 rounded-none"
                data-testid={`faq-trigger-${faq.id}`}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent
                className="px-6 pb-6 pt-0 font-body text-zinc-700 leading-relaxed"
                data-testid={`faq-content-${faq.id}`}
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
